<template>
    <div class="full-panel">
        <div class="sell-items">
            <div>
                <b-field>
                    <b-autocomplete
                            size="is-medium"
                            rounded
                            v-model="search"
                            :data="filteredProducts"
                            field="name"
                            placeholder="ຄົ້ນຫາດ້ວຍ: ລະຫັດສິນຄ້າ, ຊື່ສິນຄ້າ, ໝວດສິນຄ້າ"
                            icon="magnify"
                            clearable
                            class="my-autocomplete"
                            @select="onSelectedProduct">
                        <template slot-scope="props">
                            <div class="columns">
                                <div class="column">{{props.option.code}} / {{props.option.name}}</div>
                                <div class="column has-text-right">
                                    <strong>{{props.option.category}}</strong>
                                </div>
                            </div>
                        </template>
                        <template slot="empty">ບໍ່ພົບສິນຄ້າ</template>
                    </b-autocomplete>
                </b-field>
            </div>
            <div v-if="selectedProducts.length > 0" class="product-row">
                <div v-for="(product, index) in selectedProducts" :key="index" class="product-column">
                    <div class="product-box">
                        <div class="code">{{ product.code }}</div>
                        <b-button type="is-primary" size="is-small"
                                  icon-right="trash-can-outline"
                                  @click="removeProduct(index)"/>
                        <img v-if="product.image" :src="product.image" alt="">
                        <img v-if="!product.image" src="@/assets/images/thumbnail.png" alt="">
                        <div>
                            <div class="name">{{ product.name }}</div>
                            <div class="price">
                                <strong style="color: #e74c7f;">{{ product.price | formatMoney }}</strong> ກີບ
                            </div>
                        </div>
                        <div style="padding: 5px 40px;">
                            <b-field>
                                <b-numberinput v-model="product.items"
                                               type="is-danger"
                                               size="is-small"
                                               min="1"
                                               :max="product.qty"
                                               :editable="false"
                                               controls-position="compact"
                                               controls-rounded></b-numberinput>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sell-summary">
            <div style="padding: 16px;">
                <h1 style="font-size: 32px; font-weight: bold; text-align: center;">ສະຫຼຸບການຂາຍ</h1>
                <div class="flex" style="margin-top: 20px;">
                    <div><strong>ຈໍານວນສິນຄ້າ</strong></div>
                    <div class="flex-grow-1 has-text-right"><strong style="font-size: 16pt;">{{ totalItem }}</strong>
                        ລາຍການ
                    </div>
                </div>
                <div class="flex">
                    <div><strong>ຈໍານວນເງິນ</strong></div>
                    <div class="flex-grow-1 has-text-right"><strong style="font-size: 16pt;">{{ totalPrice | formatMoney
                        }}</strong> ກີບ
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <b-field class="payment-method" label="ຊ່ອງທາງການຊໍາລະ">
                        <b-radio-button v-model="paymentMethod"
                                        native-value="CASH">
                            <b-icon icon="cash"></b-icon>
                            <span>Cash</span>
                        </b-radio-button>
                        <b-radio-button v-model="paymentMethod"
                                        native-value="TRANSFER"
                                        type="is-primary" expanded>
                            <b-icon icon="bank-transfer"></b-icon>
                            <span>Transfer</span>
                        </b-radio-button>
                        <b-radio-button v-model="paymentMethod"
                                        native-value="ONEPAY"
                                        type="is-primary" expanded>
                            <b-icon icon="qrcode-scan"></b-icon>
                            <span>OnePay</span>
                        </b-radio-button>
                        <b-radio-button v-model="paymentMethod"
                                        native-value="COD"
                                        type="is-primary" expanded>
                            <b-icon icon="truck-delivery"></b-icon>
                            <span>COD</span>
                        </b-radio-button>
                    </b-field>
                    <b-field label="ຮັບເງິນ">
                        <b-input v-model="cash"
                                 size="is-large"
                                 class="cash-input"
                                 placeholder="ປ້ອນຈໍານວນເງິນ"
                                 :disabled="paymentMethod !== 'CASH' || this.selectedProducts.length === 0"
                                 @keyup.native="onCashInputChanged"
                                 @keypress.native="onInputNumber">
                        </b-input>
                    </b-field>
                    <b-field label="ສ່ວນຫຼຸດ"/>
                    <b-field style="display: flex;">
                        <b-radio-button style="flex: 1;" v-model="discountType"
                                        native-value="PERCENT">
                            <b-icon icon="percent"></b-icon>
                            <span>ເປີເຊັນ</span>
                        </b-radio-button>
                        <b-radio-button style="flex: 1;" v-model="discountType"
                                        native-value="FIX"
                                        type="is-primary" expanded>
                            <b-icon icon="cash-usd"></b-icon>
                            <span>ຈໍານວນເງິນ</span>
                        </b-radio-button>
                    </b-field>

                    <b-field label="">
                        <b-input class="discount-input"
                                 v-model="discountValue"
                                 @keyup.native="onPercentInputChanged"
                                 @keypress.native="onInputNumber"></b-input>
                    </b-field>
                </div>
                <div class="flex" style="margin-top: 20px;">
                    <div><strong>ສ່ວນຫຼຸດ</strong></div>
                    <div class="flex-grow-1 has-text-right"><strong style="font-size: 20pt;" class="has-text-success">{{discountPrice
                        | formatMoney}}</strong>
                        ກີບ
                    </div>
                </div>
                <div class="flex">
                    <div><strong>ເງິນທອນ</strong></div>
                    <div class="flex-grow-1 has-text-right"><strong style="font-size: 20pt;" class="has-text-success">{{cashChange
                        | formatMoney}}</strong>
                        ກີບ
                    </div>
                </div>
                <div class="flex">
                    <div><strong style="font-size: 24pt;">ລວມເງິນ</strong></div>
                    <div class="flex-grow-1 has-text-right">
                        <strong style="font-size: 24pt;"
                                :class="isMatchedPayAmount ? 'has-text-primary': 'has-text-danger'">{{payAmount |
                            formatMoney}}</strong> ກີບ
                    </div>
                </div>
            </div>
            <div class="sell-button">
                <b-button type="is-primary"
                          :disabled="payAmount <= 0 || selectedProducts.length === 0"
                          :loading="isLoading"
                          icon-left="checkbox-marked-circle-outline"
                          expanded @click="onSell">ຂາຍ
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {get} from "vuex-pathify";
    import {productsCollection, paymentsCollection, decrease} from "../firebase";

    export default {
        name: "Sell",
        data() {
            return {
                pressedKeys: "",
                isLoading: false,
                search: '',
                lastInvoice: [],
                products: [],
                selectedProducts: [],
                paymentMethod: 'CASH',
                discountType: 'PERCENT',
                discountValue: 0,
                cash: 0
            }
        },
        firestore() {
            return {
                products: productsCollection.where('deleted', '==', false).where('instock', '==', true).orderBy('created', 'desc'),
                lastInvoice: paymentsCollection.orderBy('created', 'desc').limit(1)
            }
        },
        mounted(){  
            window.addEventListener("keydown", this.onKeyDown);
        },
        beforeDestroy() {
            window.removeEventListener("keydown", this.onKeyDown);
        },
        computed: {
            user: get("userData"),
            filteredProducts() {
                return this.products.filter((option) => {
                    return option.name
                        .toString()
                        .toLowerCase()
                        .indexOf(this.search.toLowerCase()) >= 0 || option.code
                        .toString()
                        .toLowerCase()
                        .indexOf(this.search.toLowerCase()) >= 0 || option.category
                        .toString()
                        .toLowerCase()
                        .indexOf(this.search.toLowerCase()) >= 0
                })
            },
            totalItem: function () {
                let total = this.selectedProducts.reduce((o, item) => o + item.items, 0);
                // re-gen qr code
                return total;
            },
            totalPrice: function () {
                let total = this.selectedProducts.reduce((o, item) => o + item.items * item.price, 0);
                // re-gen qr code
                return total;
            },
            discountPrice() {
                let discount = 0;
                if (this.discountType === 'PERCENT') {
                    discount = (this.totalPrice * this.discountValue) / 100;
                }
                if (this.discountType === 'FIX') {
                    discount = this.discountValue.toString().replace(/,/g, '');
                }
                return parseInt(discount);
            },
            cashChange() {
                if (this.cash === 0 || isNaN(parseInt(this.cash))) return 0
                if (parseInt(this.cash.replace(/,/g, '')) - this.totalPrice <= 0) return 0
                let amount = 0;
                amount = parseInt(this.cash.replace(/,/g, '')) - this.totalPrice
                return amount + this.discountPrice;
            },
            payAmount() {
                if (this.paymentMethod !== 'CASH') {
                    return this.totalPrice - this.discountPrice;
                }
                if (this.cash === 0 || isNaN(parseInt(this.cash))) return 0
                let amount = 0;
                amount = parseInt(this.cash.replace(/,/g, '')) - parseInt(this.cashChange);
                return amount;
            },
            isMatchedPayAmount() {
                if (this.paymentMethod !== 'CASH') {
                    return true
                }
                if (this.cash === 0 || isNaN(parseInt(this.cash))) return 0
                return (parseInt(this.cash.replace(/,/g, '')) - parseInt(this.cashChange)) === this.totalPrice
            },
        },
        methods: {
            onKeyDown: function (e) {
                if (parseInt(e.key) >= 0 && parseInt(e.key) <= 9) {
                    this.pressedKeys += e.key;
                } else if (e.key === "Escape" || e.key === "F4") {
                    this.$router.replace('/dashboard');
                    this.pressedKeys = "";
                } else if (e.key === "*") {
                    this.pressedKeys = "";
                } else if (e.key === "Enter") {
                    console.log(e.key);
                }
            },
            onCashInputChanged(e) {
                let selectionStart = e.target.selectionStart;
                let originalAmount = e.target.value;
                let amountObject = Number(originalAmount.replace(/,/g, ''));
                let newAmount = amountObject.toLocaleString();
                if (isNaN(amountObject)) return;
                e.target.value = newAmount
                e.target.selectionStart = selectionStart + (newAmount.length - originalAmount.length);
                e.target.selectionEnd = e.target.selectionStart;
            },
            onPercentInputChanged(e) {
                if (this.discountType === 'PERCENT') return;
                let selectionStart = e.target.selectionStart;
                let originalAmount = e.target.value;
                let amountObject = Number(originalAmount.replace(/,/g, ''));
                let newAmount = amountObject.toLocaleString();
                if (isNaN(amountObject)) return;
                e.target.value = newAmount
                e.target.selectionStart = selectionStart + (newAmount.length - originalAmount.length);
                e.target.selectionEnd = e.target.selectionStart;
            },
            onSelectedProduct(product) {
                if (product !== null) {
                    if (this.getExisted(product)) {
                        this.showMessage('ໄດ້ເລືອກສິນຄ້າ "' + product.name + '" ແລ້ວ')
                        return
                    }
                    this.selectedProducts.push({
                        ...product,
                        id: product.id,
                        items: 1
                    })
                    console.log(this.selectedProducts);
                }
            },
            removeProduct(index) {
                const name = this.selectedProducts[index].name;
                this.selectedProducts.splice(index, 1);
                this.showMessage('ລຶບສິນຄ້າ "' + name + '" ແລ້ວ');
            },
            getExisted(product) {
                for (let i = 0; i < this.selectedProducts.length; i++) {
                    if (this.selectedProducts[i].code === product.code) {
                        if (this.selectedProducts[i].items < parseInt(this.selectedProducts[i].qty)) {
                            this.selectedProducts[i].items += 1;
                        }
                        return true;
                    }
                }

                return false;
            },
            onSell() {
                this.$swal({
                    text: "ຢືນຢັນການຂາຍ!",
                    icon: 'warning',
                    showCancelButton: true,
                }).then((result) => {
                    if (result.value) {
                        // get invoice number
                        let invoiceNumber = null;
                        if (this.lastInvoice.length > 0) {
                            invoiceNumber = this.getInvoiceNumber(parseInt(this.lastInvoice[0].invoiceNumber) + 1);
                        } else {
                            invoiceNumber = this.getInvoiceNumber(1);
                        }

                        this.isLoading = true;
                        const req = {
                            invoiceNumber: invoiceNumber,
                            paymentMethod: this.paymentMethod,
                            qty: this.totalItem,
                            currency: 'LAK',
                            total: this.totalPrice,
                            cash: this.paymentMethod === 'CASH' ? this.cash.replace(/,/g, '') : 0,
                            cashChange: this.cashChange,
                            discountType: this.discountType,
                            discountValue: this.discountValue.toString().replace(/,/g, ''),
                            referenceNumber: null,
                            items: this.selectedProducts.map(item => {
                                return {
                                    code: item.code,
                                    name: item.name,
                                    qty: item.items,
                                    price: item.price,
                                }
                            }),
                            seller: this.user.email,
                            created: this.getCurrentDateTime(),
                        }

                        //TODO: db.runTransaction

                        this.selectedProducts.forEach(item => {
                            productsCollection.doc(item.id).update({
                                qty: decrease(item.items),
                                instock: item.items < item.qty
                            }).then(res => {
                                console.log("Decrease Stock", res);
                            }).catch(err => {
                                console.log(err);
                                this.$swal('', err, 'error')
                            })
                        });

                        paymentsCollection.add(req)
                            .then(docRef => {
                                console.log(docRef.id);
                                this.$swal({
                                    text: "ການຂາຍສໍາເລັດ!",
                                    icon: 'success',
                                    showCancelButton: true,
                                }).then((result) => {
                                    this.isLoading = false;
                                    if (result.value) {
                                        this.$router.replace('/receipt/' + req.invoiceNumber);
                                    }
                                });
                            })
                            .catch(err => {
                                console.log(err);
                                this.isLoading = false;
                                this.$swal('', err, 'error')
                            })
                    }
                })
            },
            showMessage(message) {
                this.$buefy.snackbar.open({
                    duration: 2500,
                    message: message,
                    type: 'is-success',
                    position: 'is-bottom',
                    actionText: 'ຕົກລົງ',
                });
            },
        },
        watch: {
            "paymentMethod"(val) {
                if (val !== 'CASH') {
                    this.cash = 0;
                } /*else {
                    this.$nextTick(() => {
                        this.$refs.cashInput.focus()
                    })
                }*/
            },
            "discountType"(val) {
                console.log(val);
                this.discountValue = 0;
            }
        }
    }
</script>

<style scoped lang="scss">
    html {
        overflow: hidden !important;
    }

    .full-panel {
        display: flex;
        height: 100%;
        width: auto;
        text-align: left;
    }

    .sell-items {
        flex: 6.5;
        /*background-color: #F48FB1;*/
        padding: 16px;
        display: flex;
        flex-direction: column;
    }

    .sell-summary {
        flex: 3.4;
        position: relative;
        height: 100%;
        background-color: #fff;
        box-shadow: -1px 0 10px #efefef;
    }

    .sell-button {
        align-items: center;
        position: relative;
        bottom: 0;
        width: 100%;
    }

    .sell-button button {
        border-radius: 0;
        font-size: 23pt;
    }

    .flex {
        display: flex;
        font-size: 14pt;
        align-items: center;
        flex-wrap: nowrap;
        padding: 5px 0;
    }

    .flex-grow-1 {
        flex-grow: 1;
    }

    .product-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 20px;
    }

    .product-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(100% / 4);
        /*padding-right: 20px;*/
        /*padding-top: 10px;*/
        /*margin: 5px;*/
        padding-bottom: 20px;
    }

    .product-box {
        position: relative;
        width: 200px;
        height: 300px;
        background-color: #fff;
        box-shadow: 0 5px 10px #efefef;
        border-radius: 5px;
        padding-bottom: 5px;
        text-align: center;

        img {
            height: 200px;
        }

        button {
            position: absolute;
            right: 5px;
            top: 5px;
            z-index: 2;
            border-radius: 50px;
        }

        .code {
            position: absolute;
            background-color: rgba(120, 144, 156, 0.8);
            color: #fff;
            padding: 2px 10px;
        }

        .name {
            font-size: 11pt;
        }

        .price {

        }
    }
    .payment-method .control{
    }
</style>